export const OPEN = 'DEPOSIT/OPEN'
